import {
  AppNavigationEnum,
  BASEBALL_ROUTE,
  BASKETBALL_ROUTE,
  BINARY_ROUTE,
  CASINO_ROUTE,
  CompetitionViewEnum,
  CRICKET_ROUTE,
  DARTS_ROUTE,
  DASHBOARD_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  FOOTBALL_ROUTE,
  FUTSAL_ROUTE,
  GREYHOUND_ROUTE,
  HOME_ROUTE,
  HORSE_RACE_ROUTE,
  ICE_HOCKEY_ROUTE,
  IN_PLAY_ROUTE,
  INT_CASINO_ROUTE,
  KABADDI_ROUTE,
  OTHER_ROUTE,
  MMA_ROUTE,
  MULTI_MARKETS_ROUTE,
  POLITICS_ROUTE,
  RUGBY_ROUTE,
  SPORTS_BOOK_ROUTE,
  TABLE_TENNIS_ROUTE,
  TENNIS_ROUTE,
  VOLLEYBALL_ROUTE,
} from "@hypexone/uicore";

export const PREDIX_ROUTE =
  "/dc/gamev1.1/lobby-UERYX2xvYmJ5-UERY-UHJlZGlY-UHJlZGlY-TUFDNDQ0";

export const appNavigationConstants: {
  title: string;
  langKey: string;
  navigationUrl: string;
}[] = [
  {
    title: AppNavigationEnum.HOME,
    langKey: "home",
    navigationUrl: `${HOME_ROUTE}`,
  },
  {
    title: AppNavigationEnum.IN_PLAY, 
    langKey: "in_play",
    navigationUrl: `${IN_PLAY_ROUTE}`,
  },
  {
    title: AppNavigationEnum.MULTI_MARKETS,
    langKey: "multimarkets",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${MULTI_MARKETS_ROUTE}`,
  },
  
  {
    title: AppNavigationEnum.CRICKET,
    langKey: "cricket",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${CRICKET_ROUTE}`,
  },
  {
    title: AppNavigationEnum.FOOTBALL,
    langKey: "football",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${FOOTBALL_ROUTE}`,
  },
  {
    title: AppNavigationEnum.TENNIS,
    langKey: "tennis",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${TENNIS_ROUTE}`,
  },
  {
    title: "Cock Fight",
    langKey: "cock_fight",
    navigationUrl: "/dc/gamev1.1/cockfight-NDAwMzMy-U1YtTElWRS0wMDE=-QVdD-U1YzODg=-R0FQ",
  },
    {
    title: AppNavigationEnum.CASINO,
    langKey: "casino",
    navigationUrl: `${INT_CASINO_ROUTE}`,
  },
  {
    title: AppNavigationEnum.SPORTS_BOOK,
    langKey: "sports_book",
    navigationUrl: SPORTS_BOOK_ROUTE,
  },
   {
    title: AppNavigationEnum.HORSE_RACE,
    langKey: "horse_race",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${HORSE_RACE_ROUTE}`,
  },
   {
    title: AppNavigationEnum.GREYHOUND,
    langKey: "greyhound",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${GREYHOUND_ROUTE}`,
  },
  {
    title: AppNavigationEnum.BINARY,
    langKey: "binary",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${BINARY_ROUTE}`,
  },
    {
    title: AppNavigationEnum.KABADDI,
    langKey: "kabaddi",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${KABADDI_ROUTE}`,
  },
  {
    title: "Other",
    langKey: "other",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${OTHER_ROUTE}`,
  },
  {
    title: AppNavigationEnum.POLITICS,
    langKey: "politics",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${POLITICS_ROUTE}`,
  },
   {
    title: AppNavigationEnum.BASKETBALL,
    langKey: "basketball",
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${BASKETBALL_ROUTE}`,
  },
  {
    title: "PrediX",
    langKey: "predix",
    navigationUrl: PREDIX_ROUTE,
  },
  // {
  //   title: AppNavigationEnum.BASEBALL,
  //   langKey: "baseball",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${BASEBALL_ROUTE}`,
  // },
  //  {
  //   title: AppNavigationEnum.TABLE_TENNIS,
  //   langKey: "table_tennis",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${TABLE_TENNIS_ROUTE}`,
  // },
  //  {
  //   title: AppNavigationEnum.VOLLEYBALL,
  //   langKey: "volleyball",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${VOLLEYBALL_ROUTE}`,
  // },
  //  {
  //   title: AppNavigationEnum.ICE_HOCKEY,
  //   langKey: "ice_hockey",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${ICE_HOCKEY_ROUTE}`,
  // },
 
  //   {
  //   title: AppNavigationEnum.Rugby,
  //   langKey: "rugby",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${RUGBY_ROUTE}`,
  // },
  //    {
  //   title: AppNavigationEnum.MMA,
  //   langKey: "mma",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${MMA_ROUTE}`,
  // },
  //    {
  //   title: AppNavigationEnum.DARTS,
  //   langKey: "darts",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${DARTS_ROUTE}`,
  // },
  //   {
  //   title: AppNavigationEnum.FUTSAL,
  //   langKey: "futsal",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${FUTSAL_ROUTE}`,
  // },
  //   {
  //   title: AppNavigationEnum.FUTSAL,
  //   langKey: "futsal",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${FUTSAL_ROUTE}`,
  // },
  //   {
  //   title: AppNavigationEnum.FUTSAL,
  //   langKey: "futsal",
  //   navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${FUTSAL_ROUTE}`,
  // },
  
  
  

  // {
  //   title: AppNavigationEnum.INT_CASINO,
  //   navigationUrl: `${INT_CASINO_ROUTE}`,
  // },
 
 
 
 
];
export const appNavigationConstants_sports: {
  title: string;
  navigationUrl: string;
}[] = [
 
  
  {
    title: AppNavigationEnum.CRICKET,
    navigationUrl: `/exchange_sports/sports${CRICKET_ROUTE}`,
  },
  {
    title: AppNavigationEnum.FOOTBALL,
    navigationUrl: `/exchange_sports/sports${FOOTBALL_ROUTE}`,
  },
  {
    title: AppNavigationEnum.TENNIS,
    navigationUrl: `/exchange_sports/sports${TENNIS_ROUTE}`,
  },
  {
    title: "Cock Fight",
    navigationUrl: "/dc/gamev1.1/cockfight-NDAwMzMy-U1YtTElWRS0wMDE=-QVdD-U1YzODg=-R0FQ",
  },
    {
    title: AppNavigationEnum.CASINO,
    navigationUrl: `/sports_event/casino`,
  },
  {
    title: AppNavigationEnum.SPORTS_BOOK,
    navigationUrl: SPORTS_BOOK_ROUTE,
  },
   {
    title: AppNavigationEnum.HORSE_RACE,
    navigationUrl: `/exchange_sports/sports${HORSE_RACE_ROUTE}`,
  },
   {
    title: AppNavigationEnum.GREYHOUND,
    navigationUrl: `/exchange_sports/sports${GREYHOUND_ROUTE}`,
  },
  {
    title: AppNavigationEnum.BINARY,
    navigationUrl: `/exchange_sports/sports${BINARY_ROUTE}`,
  },
  {
    title: AppNavigationEnum.POLITICS,
    navigationUrl: `/exchange_sports/sports${POLITICS_ROUTE}`,
  },
   {
    title: AppNavigationEnum.BASKETBALL,
    navigationUrl: `/exchange_sports/sports${BASKETBALL_ROUTE}`,
  },
  {
    title: AppNavigationEnum.BASEBALL,
    navigationUrl: `/exchange_sports/sports${BASEBALL_ROUTE}`,
  },
   {
    title: AppNavigationEnum.TABLE_TENNIS,
    navigationUrl: `/exchange_sports/sports${TABLE_TENNIS_ROUTE}`,
  },
   {
    title: AppNavigationEnum.VOLLEYBALL,
    navigationUrl: `/exchange_sports/sports${VOLLEYBALL_ROUTE}`,
  },
   {
    title: AppNavigationEnum.ICE_HOCKEY,
    navigationUrl: `/exchange_sports/sports${ICE_HOCKEY_ROUTE}`,
  },
  {
    title: "PrediX",
    navigationUrl: PREDIX_ROUTE,
  },
    
  

  // {
  //   title: AppNavigationEnum.INT_CASINO,
  //   navigationUrl: `${INT_CASINO_ROUTE}`,
  // },
 
 
 
 
];
export const appNavigationConstants_Mobile: {
  title: string;
  navigationUrl: string;
}[] = [
 
  {
    title: AppNavigationEnum.CRICKET,
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${CRICKET_ROUTE}`,
  },
  {
    title: AppNavigationEnum.FOOTBALL,
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${FOOTBALL_ROUTE}`,
  },
  {
    title: AppNavigationEnum.TENNIS,
    navigationUrl: `${EXCHANGE_SPORTS_ROUTE}${TENNIS_ROUTE}`,
  },
  {
    title: "Cock Fight",
    navigationUrl: "/dc/gamev1.1/cockfight-NDAwMzMy-U1YtTElWRS0wMDE=-QVdD-U1YzODg=-R0FQ",
  },
    {
    title: AppNavigationEnum.CASINO,
    navigationUrl: `${INT_CASINO_ROUTE}`,
  },
  {
    title: "SB",
    navigationUrl: SPORTS_BOOK_ROUTE,
  },
];

export const competitionViewMenuOptions = [
  CompetitionViewEnum.TIME,
  CompetitionViewEnum.COMPETITION,
];
